<template>
  <div v-if="intent && !loading">
    <h4 class="mt-3 mb-2 header" style="font-size: 15px">
      {{ $t('this_message_within_24_hours') }}
    </h4>
    <h4 class="mb-2 title" v-if="isCommentToInbox">
      {{ $t(`If user haven't sent message in inbox ,The follow-up message won't be sent`) }}
    </h4>
    <template>
      <div class="form-control" style="display: flow-root">
        <toggle-button
          v-model="intent.follow_up_status"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
        {{ $t('turn_on_follow_up') }}
        <div class="mt-2">{{ $t('send_this_message_following') }}</div>
        <v-flex xs4 class="pl-1">
          <time-picker
            class="mt-1"
            v-model="intent.follow_up_within_seconds"
            full-width
            :minRange="
              !intent.follow_up_within_seconds ||
              (intent.follow_up_within_seconds &&
                (intent.follow_up_within_seconds.HH === '' ||
                  intent.follow_up_within_seconds.HH === '00'))
                ? [[5, 55]]
                : null
            "
            :minute-interval="5"
            hide-disabled-minutes
          ></time-picker>
        </v-flex>
      </div>
    </template>
    <v-layout>
      <v-flex
        v-if="showMultipleChannelFollowUp"
        class="channel"
        shrink
        style="border-right: 1px solid #eee"
      >
        <template v-for="social in $store.state.socialChannelOptions">
          <div
            :class="{ 'primary white--text': tab == social.value }"
            @click="tab = social.value"
            class="py-1 pl-2 pr-2"
            :key="social.value"
            style="
              border: 1px solid #eee;
              border-width: 1px 0px 1px 1px;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              cursor: pointer;
            "
          >
            <span :class="social.icon"></span>
          </div>
        </template>
      </v-flex>
      <v-flex style="overflow: auto" :key="timestamp">
        <template v-if="!showMultipleChannelFollowUp">
          <template v-if="isReplyComment && isCommentToInbox">
            <intent-group
              :showMultipleChannel="showMultipleChannelFollowUp"
              v-model="messages"
              :availableBubbles="['text', 'image', 'button']"
              :followUp="true"
              @changeSetting="changeSettingFollowUp"
              :isBeacon="true"
            ></intent-group>
          </template>
          <intent-group
            v-else
            :showMultipleChannel="showMultipleChannelFollowUp"
            v-model="messages"
            :availableBubbles="['text', 'image', 'button']"
            :followUp="true"
            @changeSetting="changeSettingFollowUp"
          ></intent-group>
        </template>
        <template v-else>
          <template v-for="social in $store.state.socialChannelOptions">
            <div v-show="social.value == tab" :key="`message-${social.value}`">
              <keep-alive>
                <intent-group
                  :key="`${social.value}_message`"
                  v-model="multiMessages[`follow_up_${social.value}_messages`]"
                  :showMultipleChannel="showMultipleChannelFollowUp"
                  :channel="tab"
                  @changeSetting="changeSettingFollowUp"
                  :availableBubbles="['text', 'image', 'button']"
                  :followUp="true"
                ></intent-group>
              </keep-alive>
            </div>
          </template>
        </template>

        <div>
          <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>
          <div class="mb-3"></div>

          <template v-if="!showMultipleChannelFollowUp">
            <div
              class="form-control"
              :class="{ 'has-error': errorTag['follow_up_replies'].length > 0 }"
            >
              <tags
                v-model="follow_up_reply"
                :tags="follow_up_replies"
                @tags-changed="followUpAddReplies('follow_up_replies', $event)"
                @before-adding-tag="checkQuickReply('follow_up_replies', $event)"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>
            </div>
          </template>
          <template v-else>
            <template v-for="social in $store.state.socialChannelOptions">
              <div
                class="form-control"
                :class="{
                  'has-error':
                    Object.prototype.hasOwnProperty.call(
                      errorTag,
                      `follow_up_${social.value}_replies`
                    ) && errorTag[`follow_up_${social.value}_replies`].length > 0
                }"
                :key="`message-${social.value}`"
              >
                <div v-show="social.value == tab">
                  <tags
                    v-model="multiStringReplies[`follow_up_${tab}_quick_reply`]"
                    :tags="multiReplies[`follow_up_${tab}_quick_reply`]"
                    @tags-changed="followUpAddReplies(tab, $event)"
                    @before-adding-tag="checkQuickReply(`follow_up_${tab}_replies`, $event)"
                    style="margin-bottom: 5px"
                    :btnText="$t('Add choice')"
                  ></tags>
                </div>
              </div>
            </template>
          </template>
          <div class="form-control has-error">
            <template v-for="(error, errorKey) in errorTag">
              <span :key="errorKey" class="text-error" v-if="error.length > 0">
                <template v-if="error.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="error.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="error.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </template>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-4">
      <div class="hr"></div>
      <div class="text-xs-center" style="margin: -13px">
        <a
          class="text btn-advanced"
          href="javascript:void(0);"
          @click="onShowAdvance"
          style="position: relative"
        >
          {{ $t('Advanced') }}
          <i class="fa" :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }" />
          <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
        </a>
      </div>

      <template>
        <div
          style="margin-top: 25px"
          v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
        >
          <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
            <v-tab :key="0" ripple>
              {{ $t('Customer') }}
              <!-- <a
                href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                target="blank"
              >
                <v-icon class="ml-2" small color="primary">help</v-icon>
              </a> -->
            </v-tab>
            <v-tab v-if="!isCommentToInbox" :key="1" ripple>
              {{ $t('Context') }}
              <!-- <a
                href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                target="blank"
              >
                <v-icon class="ml-2" small color="primary">help</v-icon>
              </a> -->
            </v-tab>

            <v-tab :key="2" ripple>
              {{ $t('Line Notify') }}
              <!-- <a
                href="https://blog.zwiz.ai/line-notify-%E0%B9%81%E0%B8%88%E0%B9%89%E0%B8%87%E0%B9%80%E0%B8%95%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B8%9C%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B9%84%E0%B8%A5%E0%B8%99%E0%B9%8C/"
                target="blank"
              >
                <v-icon class="ml-2" small color="primary">help</v-icon>
              </a> -->
            </v-tab>

            <v-tab-item :key="0">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="form-control mb-2">
                    <div class="primary--text caption">{{ $t('Status') }}</div>
                    <v-layout wrap>
                      <v-flex sm11>
                        <multiselect
                          :options="statusOptions"
                          v-model="intent.follow_up_userstatus"
                          :multiple="false"
                          :taggable="true"
                          @input="errorMaxlength = false"
                          @tag="onSelectStatus"
                        >
                        </multiselect>
                        <small style="color: red" v-if="errorMaxlength">
                          {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                        >
                      </v-flex>
                      <v-flex sm1>
                        <v-btn samll icon @click="intent.follow_up_userstatus = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                    <tags
                      v-if="tagOptions"
                      :combobox="true"
                      v-model="usertag"
                      :tags="usertags"
                      @tags-changed="addUserTags"
                      @before-adding-tag="checkUserTags"
                      :itemOption="tagOptions"
                      style="margin-bottom: 5px"
                      :btnText="$t('Add tag')"
                    ></tags>
                    <small style="color: red" v-if="errorMaxlengthTags">
                      {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!isCommentToInbox" :key="1">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-layout>
                    <v-flex
                      v-if="false"
                      class="form-control pr-1"
                      :class="{ 'has-error': errors.has('context_in') }"
                    >
                      <input
                        style="margin-bottom: 5px"
                        type="text"
                        class="form-control"
                        placeholder="Context In"
                        data-vv-as="Context In"
                        name="context_in"
                        v-model="intent.context_in"
                        v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                      />
                      <span class="text-error" v-show="errors.has('context_in')">{{
                        $t('Context In cannot be Comment')
                      }}</span>
                    </v-flex>
                    <v-flex class="form-control pl-1">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Context Out"
                        v-model="intent.follow_up_context_out"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="primary--text">
                    {{ $t('Line Notify') }}
                  </div>
                  <v-layout>
                    <v-flex xs8 class="pt-3">
                      {{ $t('Turn on/off Line Notify') }}
                    </v-flex>
                    <v-flex xs4 class="text-xs-right">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                          (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <toggle-button
                          class="mt-2"
                          :value="intent.follow_up_linenoti_status"
                          :sync="true"
                          :color="$vuetify.theme.success"
                          @change="toggleLineNotifyStatus"
                          :labels="{ checked: 'ON', unchecked: 'OFF' }"
                          style="display: inline-block"
                        />
                      </template>
                    </v-flex>
                  </v-layout>
                  <div class="col s12">
                    <template v-if="$store.state.linenotifylist.length == 0">
                      {{ $t('You are not connected to Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                        (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <div class="form-control">
                        <textarea
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="2000"
                          v-model="intent.follow_up_linenoti_text"
                        ></textarea>
                      </div>

                      <!-- Select line notify -->
                      <div>{{ $t('Select Line Account') }}</div>
                      <v-combobox
                        @change="selectLinenotifyUserId()"
                        v-model="selectLinenotify"
                        :items="$store.state.linenotifylist"
                        :item-text="'name'"
                        :item-value="'id'"
                        multiple
                        chips
                        outline
                        single-line
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            :selected="data.selected"
                            :disabled="data.disabled"
                            class="v-chip--select-multi"
                            @input="data.parent.selectItem(data.item.adminid)"
                          >
                            <v-avatar>
                              <v-img
                                :src="`https://graph.facebook.com/${data.item.adminid}/picture?type=square&SameSite=None`"
                              ></v-img>
                            </v-avatar>
                            {{ data.item.name }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </template>
                    <template v-else>
                      {{ $t('Not yet alert via Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </div>
    <div class="mt-4" style="margin-bottom: 15px; text-align: center">
      <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
        <em class="far fa-eye" />
        {{ $t('preview') }}
      </a>
      <preview-message
        v-if="showPreview"
        @close="showPreview = false"
        :messages="messagesPreview"
        :choice="quickReplyPreview"
      ></preview-message>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentGroup from './IntentGroup'
import TimePicker from '@/components/elements/TimePicker.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    intent: {},
    isCommentToInbox: { default: false },
    isReplyComment: { deafult: false },
    isWelcome: { default: false },
    timestamp: {},
    statusOptions: {},
    tagOptions: {},
    follow_up_selectLinenotify: {}
  },
  components: {
    Tags,
    PreviewMessage,
    IntentGroup,
    TimePicker,
    ToggleButton,
    Multiselect
  },
  data() {
    return {
      selectLinenotify: this.follow_up_selectLinenotify,
      usertag: '',
      advancedTab: null,
      showAdvanced: false,
      errorMaxlengthTags: false,
      errorMaxlength: false,
      showPreview: false,
      showMultipleChannelFollowUp: false,
      messages: [[]],
      follow_up_reply: '',
      multiMessages: {},
      multiReplies: {},
      multiStringReplies: {},
      tab: 'all',
      errorTag: {
        follow_up_replies: []
      },
      loading: true
    }
  },
  async mounted() {
    const errorTag = this.$store.state.socialChannelOptions.reduce((prev, curr) => {
      prev[`follow_up_${curr.value}_replies`] = []
      return prev
    }, {})
    this.errorTag = { ...this.errorTag, ...errorTag }
    const hasMultipleChannel = this.$store.state.socialChannelOptions.find((social) => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
        this.intent[`follow_up_${social.value}_val`]
      )
    })
    if (hasMultipleChannel) {
      this.showMultipleChannelFollowUp = true
      this.$store.state.socialChannelOptions.forEach((social) => {
        let json = [[]]
        try {
          json = Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`)
            ? this.isJsonParseable(this.intent[`follow_up_${social.value}_val`])
              ? JSON.parse(this.intent[`follow_up_${social.value}_val`])
              : this.intent[`follow_up_${social.value}_val`]
            : [[]]
        } catch (error) {
          console.error(error)
        }
        this.multiMessages[`follow_up_${social.value}_messages`] = json

        const quick_replies = this.intent[`follow_up_${social.value}_quick_reply`]
          ? this.intent[`follow_up_${social.value}_quick_reply`].split(',')
          : []
        this.multiReplies[`follow_up_${social.value}_quick_reply`] = quick_replies
        this.multiStringReplies[`follow_up_${social.value}_quick_reply`] = ''
      })
      this.tab = hasMultipleChannel.value
    }
    if (this.intent.follow_up_val) {
      this.messages = this.isJsonParseable(this.intent.follow_up_val)
        ? JSON.parse(this.intent.follow_up_val)
        : this.intent.follow_up_val
    } else {
      this.messages = [[]]
    }
    await this.$nextTick()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    messagesPreview: function () {
      if (this.tab == 'all') {
        return this.messages || [[]]
      } else {
        return this.multiMessages[`follow_up_${this.tab}_val`] || [[]]
      }
    },
    quickReplyPreview() {
      if (this.tab == 'all') {
        return this.follow_up_replies || []
      } else {
        return this.multiReplies[`follow_up_${this.tab}_replies`] || []
      }
    },
    follow_up_replies: {
      get() {
        if (
          this.intent &&
          this.intent.follow_up_quick_reply &&
          this.intent.follow_up_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = this.intent.follow_up_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_quick_reply', result.join(','))
      }
    },
    follow_up_multi_channel_replies: {
      get() {
        if (this.tab == 'all') return []
        if (
          this.intent &&
          this.intent[`follow_up_${this.tab}_quick_reply`] &&
          this.intent[`follow_up_${this.tab}_quick_reply`] !== ''
        ) {
          var quick_replies = []

          if (this.intent.a_type === 'message' || this.intent.a_type === 'generic') {
            if (this.setting.welcome_quickreplies) {
              quick_replies = this.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = this.intent[`follow_up_${this.tab}_quick_reply`].split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_ig_quick_reply', result.join(','))
      }
    },
    usertags: {
      get() {
        const vm = this
        if (vm.intent && vm.intent.follow_up_usertags && vm.intent.follow_up_usertags !== '') {
          var usertags = []

          usertags = vm.intent.follow_up_usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }

        vm.$set(this.intent, 'follow_up_usertags', result.join(','))
      }
    }
  },
  methods: {
    selectLinenotifyUserId() {
      const vm = this
      vm.$emit('update:follow_up_selectLinenotify', vm.selectLinenotify)
    },
    addUserTags: function (newTags) {
      const vm = this
      vm.usertags = newTags
    },
    checkUserTags(obj) {
      const vm = this
      vm.errorUserTags = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 25) {
        vm.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onShowAdvance: function () {
      const vm = this
      vm.showAdvanced = !vm.showAdvanced
    },
    toggleLineNotifyStatus: function () {
      const vm = this
      vm.intent.follow_up_linenoti_status = !vm.intent.follow_up_linenoti_status
    },
    onSelectStatus(value) {
      const vm = this
      if (value.length <= 25) {
        vm.errorMaxlength = false
        vm.intent.follow_up_userstatus = value
      } else {
        vm.errorMaxlength = true
      }
    },
    followUpAddReplies(type, newTags) {
      if (this.$store.state.socialChannelOptions.some((social) => type == social.value))
        this.multiReplies[`follow_up_${type}_replies`] = newTags
      else this.follow_up_replies = newTags
    },
    checkQuickReply(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        this.$store.state.socialChannelOptions.some(
          (social) =>
            type == `follow_up_${social.value}_replies` &&
            this.multiReplies[`follow_up_${social.value}_replies`].length >= 10
        )
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    async changeSettingFollowUp(payload) {
      if (payload.hasOwnProperty('showMultipleChannel')) {
        if (
          this.showMultipleChannelFollowUp != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          let cloneMessages = null
          if (this.isWelcome) {
            try {
              await this.$nextTick()
              let { messages } = this.$store.getters.welcomeMessage('all')
              cloneMessages = messages
            } catch (error) {
              console.log(error)
            }
          } else {
            cloneMessages = this.messages
          }

          this.$store.state.socialChannelOptions.forEach((social) => {
            if (social.value == 'fb' || social.value == 'ig') {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(
                  cloneMessages.map((el) => {
                    return el.filter((sel) => {
                      return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                    }, [])
                  }, [])
                )
              )
            } else {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(cloneMessages)
              )
            }
            if (!this.isWelcome)
              this.$set(
                this.intent,
                `follow_up_${social.value}_quick_reply`,
                this.intent.quick_reply
              )
          })
        }
        this.showMultipleChannelFollowUp = payload.showMultipleChannel

        if (this.showMultipleChannelFollowUp) this.tab = 'fb'
        else this.tab = 'all'
      }

      this.$emit('changeSetting', payload)
    }
  },
  watch: {
    messages: {
      handler(newVal) {
        this.intent.follow_up_val = newVal
      },
      deep: true
    },
    multiMessages: {
      handler(newVal) {
        this.$store.state.socialChannelOptions.forEach((social) => {
          this.intent[`follow_up_${social.value}_val`] =
            newVal[`follow_up_${social.value}_messages`]
        })
      },
      deep: true
    },
    multiReplies: {
      handler(newVal) {
        this.$store.state.socialChannelOptions.forEach((social) => {
          this.intent[`follow_up_${social.value}_replies`] =
            newVal[`follow_up_${social.value}_replies`]
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/FollowUpMessages.vue